module.exports = __webpack_public_path__ + "static/media/clinique_logo.814c8ab9.svg";